import React from 'react';
import VideoThumbnail from 'react-video-thumbnail';

const MediaRender = (filteredArray) => filteredArray.map((ctrl) => {
  if (ctrl.mediaType === 'image') {
    return { media: <img src={ctrl.url} alt="media" data-type="image" />, file: ctrl };
  }
  if (ctrl.mediaType === 'video') {
    return {
      media: <VideoThumbnail
        videoUrl={ctrl.url}
        snapshotAtTime={2}
      />,
      file: ctrl,
    };
  }
  return null;
});


export default MediaRender;
